var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.654 16.837c.023.052.079.082.143.075 2.558-.3 8.25-.415 7.207 1.759-1.042 2.173-13.647 1.349-14.392-.963-.72-2.237 4.035-2.703 5.288-2.706.068 0 .128-.052.147-.127.029-.11-.036-.22-.134-.223-1.601-.04-7.438.192-7.174 3.761.276 3.731 16.138 4.888 17.711 1.035 1.573-3.853-6.456-3.21-8.702-2.785-.084.022-.125.104-.094.174z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.535 13.81l-.354.353.354.354.354-.354-.354-.354zm-2.121-2.122l-.354-.354-.353.354.353.354.354-.354zm1.098-1.173l.474.159-.474-.159zm2.473 2.104l.158.475-.158-.475zm5.621-9.416l1.414 1.414.707-.707-1.414-1.414-.707.707zm-5.78 8.942l-.276.092.316.949.277-.092-.317-.95zm-1.84-1.471l.092-.277-.948-.316-.093.276.95.317zm1.173 1.805l-.978.977.708.707.977-.977-.707-.707zm-.27.977l-2.122-2.121-.707.707 2.121 2.121.708-.707zm-2.122-1.414l.978-.977-.708-.708-.977.978.707.707zM21.02 5.324l-6.216 6.217.707.707 6.216-6.217-.707-.707zM12.682 9.42L18.9 3.203l-.707-.707-6.217 6.216.707.708zm-1.645.937l.707.708a1 1 0 0 0 .242-.391l-.949-.317zm2.513 1.88a1 1 0 0 0-.391.242l.707.707-.316-.949zm.593.857a3.5 3.5 0 0 0 1.368-.846l-.707-.707a2.5 2.5 0 0 1-.978.604l.317.949zm-2.065-2.697a2.5 2.5 0 0 1 .604-.977l-.707-.708a3.5 3.5 0 0 0-.845 1.369l.948.316zm8.942-5.78a.5.5 0 0 1 0 .707l.707.707a1.5 1.5 0 0 0 0-2.121l-.707.707zm-.707-2.121a1.5 1.5 0 0 0-2.121 0l.707.707a.5.5 0 0 1 .707 0l.707-.707z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M12.535 8.86l4.95-4.95 2.828 2.828-4.95 4.95-2.828-2.828z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.353 14.87a.694.694 0 0 1-.13-.8l1.19-2.382 2.122 2.121L10.154 15a.694.694 0 0 1-.8-.13z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotation);
export default __webpack_public_path__ + "static/media/annotation.7720450eb7adcfbdc2f3fe5e45b977ad.svg";
export { ForwardRef as ReactComponent };